import { render, staticRenderFns } from "./PayoutDetails.vue?vue&type=template&id=f81303f8&scoped=true&"
import script from "./PayoutDetails.vue?vue&type=script&lang=js&"
export * from "./PayoutDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayoutDetails.vue?vue&type=style&index=0&id=f81303f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81303f8",
  null
  
)

export default component.exports